<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  //  watch: {
  //   $route(to, from) {
  //     console.log('111',to)
  //     // 对路由变化作出响应...
  //   }
  // }
}


</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.24rem;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue